import React, { useState, useEffect, Fragment } from 'react';
import { useParams } from "react-router-dom";
import { Container, Row, Col } from 'react-bootstrap';
import Moment from 'react-moment';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.paper,
        width: 500,
    },
    gridList: {
        width: 500,
        height: 450,
    },
}));
export default function Match() {

    let { id } = useParams();

    const [response, setResponse] = useState()

    const [value, setValue] = useState(0)
    const theme = useTheme();

    useEffect(() => {

        fetch('https://playattitude.fr/admin/booking/' + id, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'Bearer ' + localStorage.getItem('web_bm')
            })
        }).then(res => res.json())
            .then(res => {
                console.log(res)
                setResponse(res)
            })
    }, [])

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeIndex = index => {
        setValue(index);
    };

    const deleteBooking = () => {
        fetch('https://playattitude.fr/admin/booking/delete', {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'Bearer ' + localStorage.getItem('web_bm')
            }),
            body: JSON.stringify({booking_id: id})
        }).then(() => {
            window.location.replace("/agenda");
        })
    };

    return (

        <div id="user">
            <AppBar position="static">
                <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" centered>
                    <Tab label="Détail" {...a11yProps(0)} />
                </Tabs>
            </AppBar>
            {response &&
                <SwipeableViews
                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                    index={value}
                    onChangeIndex={handleChangeIndex}
                >

                    <TabPanel value={value} index={0}>
                        <Container fluid>
                            <Row>
                                <Col>
                                    <Row>
                                        <Col>
                                            <h2>Détail du match</h2>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <p><strong>Date :</strong> <Moment format="DD/MM/YYYY hh:mm">{response.date}</Moment></p>
                                        </Col>
                                        <Col>
                                            <p><strong>Format :</strong> {response.format}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <p><strong>Heure de début :</strong> {response.start}</p>
                                        </Col>
                                        <Col>
                                            <p><strong>Heure de fin :</strong> {response.end}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <p><strong>Ville :</strong> {response.city}</p>
                                        </Col>
                                        <Col>
                                            <p><strong>Lieu :</strong> {response.place_name}</p>
                                        </Col>
                                    </Row>
                                    {response.participants.map(participant => {
                                        return (
                                            <Row>
                                                <Col>
                                                    <p><strong>Email :</strong>{participant.email}</p>
                                                </Col>
                                                <Col>
                                                    <p><strong>Niveau :</strong>{participant.level}</p>
                                                </Col>
                                                <Col>
                                                    <p><strong>Nom :</strong>{participant.name}</p>
                                                </Col>
                                                <Col>
                                                    <p><strong>Prénom :</strong>{participant.surname}</p>
                                                </Col>
                                                <Col>
                                                    {participant.validated &&
                                                        <p>Validé</p>
                                                    }
                                                    {!participant.validated &&
                                                        <p>Non validé</p>
                                                    }
                                                </Col>
                                            </Row>
                                        )
                                    })}


                                </Col>

                            </Row>
                            <Row>
                                <Col>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick= {() => deleteBooking()}
                                    >
                                        Supprimer
                                    </Button>
                                </Col>
                            </Row>
                        </Container>
                    </TabPanel>

                </SwipeableViews>

            }
        </div>
    );
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}